export const LOAD_TAGS = "LOAD_TAGS";
export const ERROR_TAGS = "ERROR_TAGS";